import { API_PATH, SYSTEM_USER_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import client from "api/client";
import { IAuthenticationRepository } from "features/login/domain/repositories/IAuthenticationRepository";
import { injectable } from "tsyringe";
import { LoginRequestModel } from "./model/requestModel/LoginRequestModel";
import { SignUpRequestModel } from "./model/requestModel/SignUpRequestModel";
import { LoginResponseModel } from "./model/responseModel/LoginResponseModel";
import { SignUpResponseModel } from "./model/responseModel/SignUpResponseModel";

@injectable()
export class AuthenticationImpl implements IAuthenticationRepository {
  async login(
    body: LoginRequestModel,
  ): Promise<BaseApiResponseModel<LoginResponseModel>> {
    return await client?.post(API_PATH?.LOGIN, body);
  }

  async signUp(
    body: SignUpRequestModel,
  ): Promise<BaseApiResponseModel<SignUpResponseModel>> {
    return await client.post(SYSTEM_USER_MANAGEMENT.SIGN_UP, body);
  }
}
